// TablaConstantes.js
import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { Mensaje, MensajeSiNo } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';
import useTable from '../../../useTable';
import { Toasts } from '../../../toasts';
import { Input } from '../../../../ui/inputs/Input';
import { PrimaryButton } from '../../../../ui/buttons/Button';
import Constantes from './Constantes';

const TablaConstantes = (props) => {
    var op = require('../../../../modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const [showModal, setShowModal] = useState(false);
    const [operacionModal, setOperacionModal] = useState(1); // 1:Incluir, 2:Editar, 3:Eliminar, 4:Consultar
    const [codigoConstanteModal, setCodigoConstanteModal] = useState('');
    const [codigoNomina, setCodigoNomina] = useState('');
    const [usuario, setUsuario] = useState(null);
    const [conexion, setConexion] = useState(null);

    const headCells = [
        { id: 'codcons', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
        { id: 'nomcons', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRE', textAlign: 'center' },
        { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OPCIONES', textAlign: 'center' }
    ]

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtBuscador = useRef();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const permiso = JSON.parse(localStorage.getItem('accconstantes')) || "1111";
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                const query = target.value.toLowerCase();
                if (query === "") return items;
                return items.filter(x =>
                    (x.codcons?.toString().toLowerCase().includes(query)) ||
                    (x.nomcons?.toLowerCase().includes(query))
                );
            }
        });
    };

    const seleccionarRegistros = async () => {
        let codigoNominaActual = localStorage.getItem('codigonomina');
        codigoNominaActual = codigoNominaActual ? codigoNominaActual.replace(/"/g, '') : '';
        setCodigoNomina(codigoNominaActual);

        let campos = "*";
        let nomtab = `nomi${codigoNominaActual}.constantes`;
        let condi = "1=1";
        let orden = "codcons";
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

        setActivate(true);
        try {
            const response = await axios.get(endpoint, { headers: { "x-access-token": `${token}` } });
            if (response.status === 200) {
                setRecords(response.data);
            }
        } catch (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response?.data?.message || error.message, icono: 'error' });
        } finally {
            setActivate(false);
        }
    };

    const cerrarToast = () => {
        setToast({ ...toast, mostrar: false });
    }

    const obtenerUsuario = () => {
        try {
            const userData = localStorage.getItem('usuario');
            if (userData) {
                setUsuario(JSON.parse(userData));
            } else {
                setUsuario({
                    id: localStorage.getItem('idUsu') || 1,
                    nombre: localStorage.getItem('nomUsu') || 'SISTEMA',
                    cedula: localStorage.getItem('cedUsu') || '00000000'
                });
            }
        } catch (error) {
            console.error('Error obteniendo usuario:', error);
            setUsuario({ id: 1, nombre: 'SISTEMA', cedula: '00000000' });
        }
    };

    const abrirModal = (operacion, codigo) => (e) => {
        if (e) e.preventDefault();
        setOperacionModal(operacion);
        setCodigoConstanteModal(codigo || '');
        setShowModal(true);
    }

    const recargarTabla = () => {
        seleccionarRegistros();
    }

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    useEffect(() => {
        seleccionarRegistros();
        obtenerUsuario();
    }, []);

    const cerrar = () => {
        if (props.setTabla) props.setTabla(0);
    }

    const formatearCodigo = (codigo) => {
        if (!codigo) return '';
        return codigo.toString().padStart(4, '0');
    };

    return (
        <section className='col-8 m-0 p-0'>
            <header className='col-12 m-0 px-4 py-2 rounded-top d-flex align-items-center justify-content-between azulGradiant text-light'>
                <h3 className='m-0'>Gestión de Constantes</h3>
                <a type='button' onClick={cerrar} className="text-light" style={{ cursor: 'pointer' }}>
                    Salir <i className="fas fa-times ms-2"></i>
                </a>
            </header>
            
            <form onSubmit={(e) => { e.preventDefault() }} className="d-flex justify-content-between p-2">
                <div className='col-4 m-0 p-0'>
                    <Input 
                        type="text"
                        ref={txtBuscador}
                        onChange={handleSearch}
                        placeholder="Buscar por código o nombre" 
                        inputClassName='rounded-pill'
                    />
                </div>
                <PrimaryButton 
                    icon='fa-plus m-0'
                    disabled={permiso?.toString().substring(1, 2) !== '1'}
                    onClick={abrirModal(1, '')}
                    title='Agregar Constante'
                >
                    Agregar Constante
                </PrimaryButton>
            </form>
            
            <div className="">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {records && recordsAfterPagingAndSorting().map((item, index) => (
                            <tr key={index}>
                                <td className='text-center'>{formatearCodigo(item.codcons)}</td>
                                <td className='text-start'>{item.nomcons}</td>
                                <td className='text-center'>
                                    <button 
                                        onClick={abrirModal(4, item.codcons)} 
                                        className={permiso?.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                        title="Consultar"
                                        disabled={permiso?.toString().substring(0, 1) !== '1'}
                                    >
                                        <i className="fas fa-eye"></i>
                                    </button>
                                    {' '}
                                    <button 
                                        onClick={abrirModal(2, item.codcons)} 
                                        className={permiso?.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                        title="Editar"
                                        disabled={permiso?.toString().substring(2, 3) !== '1'}
                                    >
                                        <i className="fa fa-edit"></i>
                                    </button>
                                    {' '}
                                    <button 
                                        onClick={abrirModal(3, item.codcons)} 
                                        className={permiso?.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                        title="Eliminar"
                                        disabled={permiso?.toString().substring(3, 4) !== '1'}
                                    >
                                        <i className="fa fa-trash-alt"></i>
                                    </button>
                                </td>
                             </tr>
                        ))}
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>

            <Constantes 
                show={showModal}
                setShow={setShowModal}
                setTabla={recargarTabla}
                conexion={conexion}
                codigoNomina={codigoNomina}
                usuario={usuario}
                codigoConstante={codigoConstanteModal}
                operacion={operacionModal}
            />

            <Dimmer active={activate} inverted />
            <Mensaje mensaje={mensaje} onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino} onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            <Toasts show={toast.mostrar} titulo={toast.titulo} mensaje={toast.mensaje} onHideCancela={cerrarToast} />
        </section>
    );
}

export default TablaConstantes;